export const defaultLanguage = 'en';
